export default "assets/images/icons/marker-25df7329.svg";